const state = {
    Bund: [],
    Verband: [],
    Disziplinen: [],
    Users: [],
    Clubs: [],
    FEEDBACK: [],

};

export default state;
